import { render, staticRenderFns } from "./PointsPackageDialog.vue?vue&type=template&id=75093c49&scoped=true&"
import script from "./PointsPackageDialog.vue?vue&type=script&lang=js&"
export * from "./PointsPackageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75093c49",
  null
  
)

export default component.exports